export default "__VITE_ASSET__CqT1obQ5__"